import React, { Component } from 'react';
import { observer } from 'mobx-react';
import Progress from '../../../components/progress/index';
import ProgressText from '../../../components/progress-text/Progress';
import Button from '../../../components/button/Button';
import { getVersion, upgradeGeo } from '../../../service/command';
import { getUpgradeInfo } from '../../../service/index';
import { downloadUpgradeFile } from '../../../native-interact/native-interface';
import { transformTime, compareVersion } from '../../../js/utils';
import Toast from '../../../components/toast/Toast';

class Upgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: '',
      md5: '',
      curStatus: 'loading', // 当前版本号获取状态
      newStatus: 'loading' // 最新版本号获取状态
    };
  }

  componentDidMount() {
    // 每次显示如果不是正在升级中就重新获取一次最新版本，保证每次点开都可以更新版本号
    if (this.props.store.status !== 'loading') {
      this.init();
      return;
    }
    if (this.props.store.module === 'cpu2') {
      this.setState({
        curStatus: 'success',
        newStatus: 'success'
      });
    } else {
      Toast.fail(`${this.props.store.module}正在升级中，请等待升级结束后重试`);
    }
  }

  componentWillUnmount() {
    if (this.props.store.status !== 'loading') {
      clearInterval(this.timer);
    }

    // 卸载异步操作设置状态
    this.setState = () => {
      return null;
    };
  }

  onUpgrade() {
    const { url, md5 } = this.state;

    this.props.store.module = 'cpu2';

    downloadUpgradeFile('cpu2', url, md5).then(() => {
      this.props.store.status = 'loading';
      upgradeGeo('cpu2', 'bt').then(() => {
        this.props.store.startTime = new Date();
        this.startCount();
      });
    }).catch(() => {
      this.props.store.module = '';
    });
  }

  getDevType() {
    return 'FRANK_CPU2';
  }

  init() {
    // 查询当前地磁版本号
    getVersion('cpu2').then((version) => {
      this.props.store.version = version.version;
      this.props.store.firmwaretype = version.firmwaretype;
      this.setState({
        curStatus: 'success'
      });
      // 获取最新版本号
      getUpgradeInfo(this.getDevType(), version.firmwaretype).then((data) => {
        this.props.store.newVersion = data.version;
        this.setState({
          newStatus: 'success',
          url: data.download_url,
          md5: data.MD5
        });
      }).catch(() => {
        this.setState({
          newStatus: 'error'
        });
      });
    }).catch(() => {
      this.setState({
        curStatus: 'error'
      });
    });
  }

  startCount() {
    this.timer = setInterval(() => {
      const { startTime } = this.props.store;
      if (!startTime) {
        clearInterval(this.timer);
      } else {
        this.props.store.spendTime = transformTime(Date.now() - startTime);
      }
    }, 1000);
  }

  render() {
    const that = this;
    const { curStatus, newStatus } = this.state;
    const { RFID } = this.props.readStore;
    const { version, newVersion, progress, status, spendTime } = this.props.store;
    const statusComp = (function () {
      if (status === 'default') {
        if (compareVersion(newVersion, version)) {
          return (
            <div style={{ textAlign: 'center' }}>
              <Button type="primary" onClick={() => that.onUpgrade()}>升级</Button>
            </div>
          );
        }
        return <div style={{ textAlign: 'center', color: '#409EFF' }}>当前已是最新版本</div>;
      }
      if (status === 'loading') {
        return (
          <div style={{ padding: '5px 0' }}>
            <Progress
              rate={progress}
            />
            <div style={{ textAlign: 'center', color: 'red' }}>升级中，请勿退出</div>
          </div>
        );
      }
      if (status === 'fail') {
        return (
          <div style={{ textAlign: 'center', color: 'red' }}>
            升级失败，<a style={{ color: '#409EFF', textDecoration: 'underline' }} onClick={() => that.onUpgrade()}>点击重试</a>
          </div>
        );
      }
      return '';
    }());

    return (
      <div>
        <h4 className="popup-title">CPU2升级<span style={{ float: 'right', color: '#409EFF' }}>{spendTime}</span></h4>
        <p className="popup-p">RFID：{RFID}</p>
        <ProgressText
          text="当前版本号："
          success={`当前版本号：v${version}`}
          error="当前版本号：获取失败"
          status={curStatus}
        />
        <ProgressText
          text="最新版本号："
          success={`最新版本号：v${newVersion}`}
          error="最新版本号：获取失败"
          status={newStatus}
        />
        {statusComp}
      </div>
    );
  }
}

export default observer(Upgrade);
